// JWT utility functions
export const decodeToken = (token) => {
  if (!token) return null;
  
  try {
    // JWT tokens have 3 parts: header.payload.signature
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

export const getCurrentUserId = () => {
  const token = localStorage.getItem('token');
  const decoded = decodeToken(token);
  return decoded?.userId || null;
};

export const isTokenExpired = (token) => {
  const decoded = decodeToken(token);
  if (!decoded || !decoded.exp) return true;
  
  const currentTime = Date.now() / 1000;
  return decoded.exp < currentTime;
};

export const isAuthenticated = () => {
  const token = localStorage.getItem('token');
  return token && !isTokenExpired(token);
};